import { isPointedToProd } from "../../common/providers/mosaic/point-to-prod";

const overleafHost = isPointedToProd()
  ? "flashcards.vitalsource.com"
  : process.env.REACT_APP_OVERLEAF_HOST;

export const overleafScript = `//${overleafHost}/js/v2/app.js?v=${Date.now()}`;

export const MediaTypes = {
  IMAGE: "image",
  TEXT: "text",
};

export enum ConfidenceLevel {
  Unknown,
  Low,
  High,
}

export const convertFullUrlToContentUrl = (fullUrl: string) => {
  const re = new RegExp("//[^/]+/books/([^/]+)/epub/(.+)");
  const result = re.exec(fullUrl);
  if (result) {
    return `vstcontent://${result[1]}/${result[2]}`;
  }
  return fullUrl;
};

export const convertContentUrlToFullUrl = (storedUrl: string) => {
  const re = new RegExp("vstcontent://([^/]+)/(.+)");
  const result = re.exec(storedUrl);
  if (result) {
    return `//${window.Jigsaw.host}/books/${result[1]}/epub/${result[2]}`;
  }
  return storedUrl;
};

export const processCardSide = (side) => {
  if (side.type === MediaTypes.IMAGE) {
    return {
      ...side,
      content: convertContentUrlToFullUrl(side.content),
    };
  } else {
    return side;
  }
};

export const processProficiencies = (proficiencies) => {
  if (!proficiencies.length) {
    return ConfidenceLevel.Unknown;
  } else {
    const level = proficiencies[0].level;
    return level === 100 ? ConfidenceLevel.High : ConfidenceLevel.Low;
  }
};
